import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { bypassAuthPost } from '../../../../api-client/api-gqcust-client';

export const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const bypassAuthenticationPost = createAsyncThunk(
    'bypassAuthentication/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await bypassAuthPost(body);
            const data = response?.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_BYPASS_AUTH_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

const bypassAuthenticationPostSlice = createSlice({
    name: 'bypassAuthenticationPost',
    initialState,
    extraReducers: {
        [bypassAuthenticationPost.pending]: (state) => {
            state.loading = true;
        },
        [bypassAuthenticationPost.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [bypassAuthenticationPost.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const bypassAuthenticationPostSelector = (state) => state.bypassAuthenticationPost;
export const bypassAuthenticationPostReducer = bypassAuthenticationPostSlice.reducer;
